import { useState, useEffect } from "react";
import "./index.scss";

export interface TabItem {
  key: string;
  label: string;
}

interface TabsProps {
  tabs: TabItem[];
  defaultActiveKey?: string;
  activeKey?: string;
  onChange: (key: string) => void;
}

export function Tabs({
  tabs,
  defaultActiveKey,
  activeKey,
  onChange,
}: TabsProps) {
  const isControlled = activeKey !== undefined;
  const [internalActiveTab, setInternalActiveTab] = useState(
    defaultActiveKey || tabs[0]?.key
  );

  const activeTab = isControlled ? activeKey : internalActiveTab;

  const handleChange = (key: string) => {
    setInternalActiveTab(key);
    onChange?.(key);
  };

  useEffect(() => {
    if (!isControlled && defaultActiveKey) {
      setInternalActiveTab(defaultActiveKey);
    }
  }, [defaultActiveKey, isControlled]);

  return (
    <ul className="nav nav-tabs custom-tabs">
      {tabs.map((tab) => (
        <li className="nav-item" key={tab.key}>
          <button
            type="button"
            className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => handleChange(tab.key)}
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
